import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-print-email',
  templateUrl: './print-email.component.html',
  styleUrls: ['./print-email.component.css']
})
export class PrintEmailComponent implements OnInit {

  @Input() Send: {id: number, subject: string, body: string, stampa: number};
  @Input() IsModal: boolean = true;
  @Output() onSend = new EventEmitter<{id: number, subject: string, body: string, stampa: number}>();

  constructor(
    private ngbActiveModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

  closeBtnClick() {
    this.ngbActiveModal.dismiss();
  }

  send() {
    this.onSend.emit(this.Send);
    this.ngbActiveModal.dismiss();
  }
}
